export default __webpack_public_path__ + "static/media/img-1.13eee40c.png";